const config = {
    OKTA_AUTH: {
        issuer: process.env.REACT_APP_OKTA_ISSUER,
        clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
        redirectUri: window.location.origin + '/login/callback',
        scopes: ['openid', 'email', 'groups']
    },
}

export default config;